export const de = {
    // Navigation
    navigation: {
      features: 'Features',
      howItWorks: 'So funktioniert\'s',
      templates: 'Vorlagen',
      pricing: 'Preise',
      faq: 'FAQ',
      getStartedFree: 'Jetzt starten',
      back: 'Zurück',
      backGerman: 'Zurück',
      close: 'Schließen'
    },
  
      // Header and Navigation
  header: {
    saveFile: 'Datei speichern',
    exportPdf: 'PDF exportieren',
    exporting: 'Zahlung wird verarbeitet...',
    showEditorInputs: 'Eingabe-Editor anzeigen',
    showSettings: 'Einstellungen anzeigen',
    typography: 'Typografie',
    backupReminder: {
      title: 'Verlieren Sie Ihre Arbeit nicht!',
      message: 'Speichern Sie eine kostenlose Sicherung für später',
      dismiss: 'Verstanden',
      saveNow: 'Jetzt speichern'
    }
  },
  
      // Common Actions
  actions: {
    tip: 'Tipp',
    add: 'Hinzufügen',
      edit: 'Bearbeiten',
      delete: 'Löschen',
      remove: 'Entfernen',
      save: 'Speichern',
      cancel: 'Abbrechen',
      close: 'Schließen',
      open: 'Öffnen',
      done: 'Fertig',
      confirm: 'Bestätigen',
      apply: 'Anwenden',
      reset: 'Zurücksetzen',
      clear: 'Löschen',
      clearAll: 'Alle löschen',
      upload: 'Hochladen',
      download: 'Herunterladen',
      import: 'Importieren',
      export: 'Exportieren',
      preview: 'Vorschau',
      next: 'Weiter',
      previous: 'Zurück',
      back: 'Zurück',
      continue: 'Fortfahren',
      start: 'Starten',
      finish: 'Abschließen',
      copy: 'Kopieren',
      paste: 'Einfügen',
      cut: 'Ausschneiden',
      undo: 'Rückgängig',
      redo: 'Wiederholen',
      select: 'Auswählen',
      selectAll: 'Alle auswählen',
      none: 'Keine',
      all: 'Alle',
      loading: 'Lädt...',
      processing: 'Verarbeite...',
      success: 'Erfolg',
      error: 'Fehler',
      warning: 'Warnung',
      info: 'Information',
      required: 'Erforderlich',
      optional: 'Optional',
      show: 'Anzeigen',
      hide: 'Ausblenden',
      expand: 'Erweitern',
      collapse: 'Einklappen',
      minimize: 'Minimieren',
      maximize: 'Maximieren',
      refresh: 'Aktualisieren',
      reload: 'Neu laden',
      retry: 'Erneut versuchen',
      search: 'Suchen',
      filter: 'Filter',
      sort: 'Sortieren',
      view: 'Ansicht',
      browse: 'Durchsuchen'
    },
  
    // Mobile Navigation
    mobile: {
      stylingOptions: 'Gestaltungsoptionen',
      importExport: 'Import/Export',
      saveAsJson: 'Als JSON speichern',
      loadFromJson: 'Aus JSON laden',
      selectTemplate: 'Vorlage auswählen',
      changeLayout: 'Layout ändern',
      changeDesign: 'Design ändern',
      changeStyle: 'Stil ändern',
      changeBackground: 'Hintergrund ändern',
      typographySettings: 'Typografie-Einstellungen',
      language: 'Sprache',
      showEditorInputs: 'Editor-Eingaben anzeigen',
          previewMode: 'Vorschaumodus',
    exportPdf: 'PDF exportieren',
    clearAllData: 'Alle Daten löschen',
      editResume: 'Lebenslauf bearbeiten',
      previewResume: 'Lebenslauf-Vorschau',
      gestureHint: 'Zoomen mit zwei Fingern • Ziehen zum Bewegen'
    },
  
    // Form sections
    sections: {
      personalInfo: 'Persönliche Informationen',
      professionalSummary: 'Beruflicher Werdegang',
      workExperience: 'Berufserfahrung',
      education: 'Bildung',
      skills: 'Fähigkeiten',
      projects: 'Projekte',
      certifications: 'Zertifizierungen',
      awards: 'Auszeichnungen und Ehrungen',
      languages: 'Sprachen',
      volunteerExperience: 'Ehrenamtliche Erfahrung',
      publications: 'Veröffentlichungen',
      references: 'Referenzen'
    },

    // Input section titles (for cards)
    inputSection: {
      sections: {
        'Personal Information': 'Persönliche Informationen',
        'Professional Summary': 'Beruflicher Werdegang',
        'Work Experience': 'Berufserfahrung',
        'Education': 'Bildung',
        'Skills': 'Fähigkeiten',
        'Projects': 'Projekte',
        'Certifications': 'Zertifizierungen',
        'Awards and Honors': 'Auszeichnungen und Ehrungen',
        'Languages': 'Sprachen',
        'Volunteer Experience': 'Ehrenamtliche Erfahrung',
        'Publications': 'Veröffentlichungen',
        'References': 'Referenzen'
      },
      defaultTitles: {
        experience: 'Erfahrung',
        education: 'Bildung',
        skill: 'Fähigkeit',
        project: 'Projekt',
        certification: 'Zertifizierung',
        award: 'Auszeichnung',
        language: 'Sprache',
        volunteer: 'Ehrenamtliche Tätigkeit',
        publication: 'Veröffentlichung',
        reference: 'Referenz'
      }
    },

    // Layout names and categories
    layoutNames: {
      // Layout categories
      'Classic': 'Klassisch',
      'Sidebar': 'Seitenleiste',
      'Topbar': 'Oberleiste',
      
      // Individual layout names
      'Centered Title': 'Zentrierter Titel',
      'Right-Aligned Title': 'Rechtsbündiger Titel',
      'Left-Aligned Title': 'Linksbündiger Titel',
      'Sidebar Left': 'Seitenleiste Links',
      'Sidebar Right': 'Seitenleiste Rechts',
      
      // Layout descriptions
      descriptions: {
        'centered-header': 'Professionelles Layout mit zentriertem Header',
        'right-aligned-header': 'Modernes Layout mit rechtsbündigem Header',
        'left-aligned-header': 'Modernes Layout mit linksbündigem Header',
        'sidebar-left': 'Layout mit Fähigkeiten und Kontakt in linker Seitenleiste',
        'sidebar-right': 'Layout mit Fähigkeiten und Kontakt in rechter Seitenleiste',
        'topbar-centered': 'Layout mit Fähigkeiten und Kontakt in zentrierter Oberleiste',
        'topbar-right': 'Layout mit Fähigkeiten und Kontakt in rechtsbündiger Oberleiste',
        'topbar-left': 'Layout mit Fähigkeiten und Kontakt in linksbündiger Oberleiste'
      }
    },

    // Design names and categories
    designNames: {
      // Design categories
      'default': 'Standard',
      'tech': 'Technisch',
      'professional': 'Professionell',
      
      // Individual design names
      'default-black': 'Schwarz',
      'default-gray': 'Grau',
      'blue': 'Blau',
      'green': 'Grün',
      'orange': 'Orange',
      'colorful': 'Bunt',
      'gradient': 'Verlauf',
      'vibrant-yellow': 'Lebendiges Gelb',
      'navy-professional': 'Marineblau',
      'charcoal-professional': 'Holzkohle',
      'beige-professional': 'Beige',
      'olive-professional': 'Oliv',
      'teal-professional': 'Blaugrün',
      'burgundy-professional': 'Burgunderrot'
    },

    // Template categories
    templateCategories: {
      'Classic': 'Klassisch',
      'Classic Centered Timeline': 'Klassisch Zentrierte Zeitleiste',
      'Sidebar Right Classic': 'Seitenleiste Rechts Klassisch',
      'Sidebar Left Classic': 'Seitenleiste Links Klassisch',
      'Sidebar Right Modern': 'Seitenleiste Rechts Modern',
      'Sidebar Left Modern': 'Seitenleiste Links Modern',
      'Topbar Classic': 'Oberleiste Klassisch',
      'Topbar Modern': 'Oberleiste Modern',
      'Tech': 'Technisch',
      'Triangular': 'Dreieckig',
      'Geometric': 'Geometrisch',
      'Other': 'Andere'
    },
  
    // Form components
    forms: {
      personalInfo: {
        title: 'Persönliche Informationen',
        profilePicture: 'Profilbild',
        uploadPicture: 'Bild hochladen',
        removePicture: 'Bild entfernen',
        enablePictureSpace: 'Bildbereich aktivieren',
        enablePictureSpaceHelper: 'Platz für Profilbild reservieren, auch wenn kein Bild hochgeladen ist',
        firstName: 'Vorname',
        lastName: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        address: 'Adresse',
        linkedin: 'LinkedIn',
        github: 'GitHub',
        linkedinPlaceholder: 'https://linkedin.com/in/ihrprofil',
        githubPlaceholder: 'https://github.com/ihrbenutzername'
      }
    },
  
    // Personal Information Fields
    personalInfo: {
      firstName: 'Vorname',
      lastName: 'Nachname',
      email: 'E-Mail',
      phone: 'Telefon',
      address: 'Adresse',
      linkedin: 'LinkedIn',
      github: 'GitHub',
      website: 'Website',
      uploadPicture: 'Bild hochladen',
      removePicture: 'Bild entfernen',
      enablePictureSpace: 'Bildbereich aktivieren',
      enablePictureSpaceHelper: 'Platz für Profilbild reservieren, auch wenn kein Bild hochgeladen ist',
      cropProfilePicture: 'Profilbild zuschneiden',
      dragToPosition: 'Ziehen Sie das Bild, um es im Kreis zu positionieren',
      zoom: 'Zoom',
      dragToReposition: 'Ziehen zum Neupositionieren'
    },
  
    // Work Experience Fields
    workExperience: {
      company: 'Unternehmen',
      jobTitle: 'Stellenbezeichnung',
      location: 'Ort',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      currentPosition: 'Aktuelle Position',
      description: 'Beschreibung',
      addExperience: 'Erfahrung hinzufügen',
      experience: 'Erfahrung'
    },
  
    // Education Fields
    education: {
      school: 'Bildungseinrichtung',
      degree: 'Abschluss',
      fieldOfStudy: 'Studienrichtung',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      description: 'Beschreibung',
      addEducation: 'Ausbildung hinzufügen',
      education: 'Ausbildung'
    },
  
    // Skills Fields
    skills: {
      displayAscategories: 'Als Kategorien anzeigen',
      displayAsIndividual: 'Als einzelne Fähigkeiten anzeigen',
      skillCategory: 'Fähigkeits-Kategorie',
      skillsCommaSeparated: 'Fähigkeiten (kommagetrennt)',
      skillName: 'Fähigkeitsname',
      proficiency: 'Kenntnisstand',
      addSkill: 'Fähigkeit hinzufügen',
      skill: 'Fähigkeit',
      skillCategory: 'Fähigkeits-Kategorie',
      expert: 'Experte',
      advanced: 'Fortgeschritten',
      intermediate: 'Mittel',
      basic: 'Grundkenntnisse',
      beginner: 'Anfänger'
    },
  
    // Languages Fields
    languages: {
      language: 'Sprache',
      proficiency: 'Kenntnisstand',
      addLanguage: 'Sprache hinzufügen',
      native: 'Muttersprache / Zweisprachig (C2)',
      fluent: 'Fließend (C1)',
      advanced: 'Fortgeschritten (B2)',
      intermediate: 'Mittel (B1)',
      basic: 'Grundkenntnisse (A2)',
      beginner: 'Anfänger (A1)'
    },
  
    // Projects Fields
    projects: {
      projectName: 'Projektname',
      technologiesUsed: 'Verwendete Technologien',
      projectLink: 'Projekt-Link',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      description: 'Beschreibung',
      addProject: 'Projekt hinzufügen',
      project: 'Projekt'
    },
  
    // Certifications Fields
    certifications: {
      certificationName: 'Zertifikatsname',
      issuingOrganization: 'Ausstellende Organisation',
      issueDate: 'Ausstellungsdatum',
      credentialId: 'Berechtigungsnachweis-ID',
      credentialUrl: 'Berechtigungsnachweis-URL',
      addCertification: 'Zertifikat hinzufügen',
      certification: 'Zertifikat'
    },
  
    // Awards Fields
    awards: {
      awardTitle: 'Auszeichnung',
      issuer: 'Aussteller',
      date: 'Datum',
      description: 'Beschreibung',
      addAward: 'Auszeichnung hinzufügen',
      award: 'Auszeichnung'
    },
  
    // Volunteer Experience Fields
    volunteer: {
      organization: 'Organisation',
      role: 'Rolle',
      startDate: 'Startdatum',
      endDate: 'Enddatum',
      description: 'Beschreibung',
      addVolunteerExperience: 'Ehrenamtliche Tätigkeit hinzufügen',
      volunteerExperience: 'Ehrenamtliche Tätigkeit'
    },
  
    // Publications Fields
    publications: {
      publicationTitle: 'Titel der Veröffentlichung',
      publisher: 'Herausgeber',
      publicationDate: 'Veröffentlichungsdatum',
      url: 'URL',
      description: 'Beschreibung',
      addPublication: 'Veröffentlichung hinzufügen',
      publication: 'Veröffentlichung'
    },
  
    // References Fields
    references: {
      referenceName: 'Name der Referenz',
      position: 'Position',
      company: 'Unternehmen',
      email: 'E-Mail',
      phone: 'Telefon',
      addReference: 'Referenz hinzufügen',
      reference: 'Referenz'
    },
  
    // Settings
    settings: {
      layout: 'Layout',
      design: 'Design',
      typography: 'Typografie',
      style: 'Stil',
      background: 'Hintergrund',
      template: 'Vorlage',
      specialEffects: 'Spezialeffekte',
      barStyle: 'Balken-Stil',
      chooseLayout: 'Layout wählen',
      chooseDesign: 'Design wählen',
      chooseStyle: 'Stil wählen',
      chooseBackground: 'Hintergrund wählen',
      applyTemplate: 'Vorlage anwenden',
      selectEffect: 'Effekt auswählen',
      selectBarStyle: 'Balken-Stil auswählen'
    },
  
    // Layout categories
    layouts: {
      classic: 'Klassisch',
      modern: 'Modern',
      creative: 'Kreativ',
      professional: 'Professionell',
      academic: 'Akademisch',
      technical: 'Technisch',
      sidebar: 'Seitenleiste',
      topbar: 'Kopfleiste',
      centered: 'Zentriert',
      left: 'Linksbündig',
      right: 'Rechtsbündig'
    },
  
    // Design categories
    designs: {
      professional: 'Professionell',
      tech: 'Tech',
      creative: 'Kreativ',
      default: 'Standard',
      navy: 'Marine',
      beige: 'Beige',
      burgundy: 'Burgunder',
      charcoal: 'Kohle',
      olive: 'Olive',
      teal: 'Blaugrün',
      blue: 'Blau',
      colorful: 'Bunt',
      gradient: 'Verlauf',
      green: 'Grün',
      orange: 'Orange',
      vibrantYellow: 'Lebendiges Gelb',
      black: 'Schwarz',
      gray: 'Grau'
    },
  
    // Background types
    backgrounds: {
      blank: 'Leer',
      tech: 'Tech-Muster',
      professional: 'Professionell',
      geometric: 'Geometrisch',
      triangle: 'Dreieck',
      rainbow: 'Regenbogen-Streifen',
      descriptions: {
        blank: 'Einfacher weißer Hintergrund, keine Effekte.',
        tech: 'Subtiles animiertes Muster mit Tech-Icons.',
        professional: 'Ein sauberer und professioneller Hintergrund mit Fokus auf Struktur.',
        geometric: 'Subtile diagonale Linien bilden ein geometrisches Muster.',
        triangle: 'Saubere dreieckige Formen oben und unten auf der Seite.',
        rainbow: 'Bunte diagonale Streifen in der oberen rechten und unteren linken Ecke.'
      }
    },
  
    // Bar styles for proficiency visualization
    barStyles: {
      none: 'Keine',
      text: 'Text',
      stars: 'Sterne',
      bars: 'Balken',
      circles: 'Kreise',
      squares: 'Quadrate',
      descriptions: {
        none: 'Keine visuelle Kenntnisanzeige.',
        text: 'Kenntnisstand als Text anzeigen (z.B. Mittel).',
        stars: 'Kenntnisstand als Sterne-Reihe (1-5).',
        bars: 'Kenntnisstand als horizontale Balken (1-5).',
        circles: 'Kenntnisstand als Kreis-Reihe (1-5).',
        squares: 'Kenntnisstand als Quadrat-Reihe (1-5).'
      }
    },
  
    // Special effects
    specialEffects: {
      none: 'Keine',
      timeline: 'Timeline-Effekt',
      descriptions: {
        none: 'Keine Spezialeffekte angewendet.',
        timeline: 'Fügt eine visuelle Timeline hinzu, die datierte Abschnitte verbindet.'
      }
    },

    // Style names
    styles: {
      default: 'Standard',
      tech: 'Technisch',
      professional: 'Professionell',
      blank: 'Leer',
      descriptions: {
        default: 'Sauberes Aussehen, keine zusätzlichen Icons oder Rahmen.',
        tech: 'Modernes tech-fokussiertes Styling mit Icons.',
        professional: 'Professionelles Styling mit subtilen Rahmen.',
        blank: 'Minimales Styling ohne dekorative Elemente.'
      }
    },
  
    // Typography settings
    typography: {
      fontFamily: 'Schriftart',
      fontSize: 'Schriftgröße',
      lineHeight: 'Zeilenhöhe',
      global: 'Globale Einstellungen',
      headers: 'Überschriften',
      body: 'Fließtext',
      small: 'Kleiner Text',
      resetToDefaults: 'Auf Standard zurücksetzen',
      small: 'Klein',
      medium: 'Mittel',
      large: 'Groß',
      extraLarge: 'Extra groß'
    },
  
    // File operations
    file: {
      selectFile: 'Datei auswählen',
      uploadFile: 'Datei hochladen',
      importFromFile: 'Aus Datei importieren',
      exportToFile: 'In Datei exportieren',
      supportedFormats: 'Unterstützte Formate',
      fileSize: 'Dateigröße',
      fileName: 'Dateiname',
      invalidFile: 'Ungültiges Dateiformat',
      fileTooLarge: 'Datei zu groß',
      uploadError: 'Upload-Fehler',
      processing: 'Datei wird verarbeitet...',
      parseError: 'Fehler beim Parsen der Datei'
    },
  
    // Welcome screen
    welcome: {
      title: 'Willkommen beim CV Builder',
      subtitle: 'Erstellen Sie Ihren professionellen Lebenslauf in wenigen Minuten',
      startManual: 'Von vorne beginnen',
      uploadResume: 'Vorhandenen Lebenslauf hochladen',
      importLinkedIn: 'Von LinkedIn importieren',
      importOptions: 'Import-Optionen',
      getStarted: 'Loslegen',
      chooseOption: 'Wählen Sie, wie Sie beginnen möchten'
    },
  
    // Preview and export
    preview: {
      livePreview: 'Live-Vorschau',
      pageControls: 'Seitensteuerung',
      zoomIn: 'Vergrößern',
      zoomOut: 'Verkleinern',
      fitToWidth: 'An Breite anpassen',
      actualSize: 'Originalgröße',
      fullscreen: 'Vollbild',
      exitFullscreen: 'Vollbild verlassen',
      previousPage: 'Vorherige Seite',
      nextPage: 'Nächste Seite',
      page: 'Seite',
      of: 'von'
    },
  
    // Validation messages
    validation: {
      required: 'Dieses Feld ist erforderlich',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
      invalidUrl: 'Bitte geben Sie eine gültige URL ein',
      tooShort: 'Dieses Feld ist zu kurz',
      tooLong: 'Dieses Feld ist zu lang',
      invalidDate: 'Bitte geben Sie ein gültiges Datum ein',
      endDateBeforeStart: 'Das Enddatum kann nicht vor dem Startdatum liegen'
    },
  
    // Error messages
    errors: {
      generic: 'Ein Fehler ist aufgetreten',
      networkError: 'Netzwerkfehler. Bitte überprüfen Sie Ihre Verbindung.',
      fileNotFound: 'Datei nicht gefunden',
      parseError: 'Fehler beim Parsen der Daten',
      exportError: 'Fehler beim Exportieren der Datei',
      importError: 'Fehler beim Importieren der Datei',
      saveFailed: 'Speichern fehlgeschlagen',
      loadFailed: 'Laden der Daten fehlgeschlagen',
      invalidData: 'Ungültiges Datenformat',
      permissionDenied: 'Berechtigung verweigert',
      timeout: 'Zeitüberschreitung der Anfrage',
      serverError: 'Serverfehler aufgetreten'
    },
  
    // Success messages
    success: {
      saved: 'Erfolgreich gespeichert',
      exported: 'Erfolgreich exportiert',
      imported: 'Erfolgreich importiert',
      updated: 'Erfolgreich aktualisiert',
      deleted: 'Erfolgreich gelöscht',
      copied: 'In die Zwischenablage kopiert',
      reset: 'Auf Standard zurückgesetzt'
    },
  
    // Date and time
    dateTime: {
      today: 'Heute',
      yesterday: 'Gestern',
      tomorrow: 'Morgen',
      present: 'Aktuell',
      current: 'Derzeit',
      ongoing: 'Laufend',
      january: 'Januar',
      february: 'Februar',
      march: 'März',
      april: 'April',
      may: 'Mai',
      june: 'Juni',
      july: 'Juli',
      august: 'August',
      september: 'September',
      october: 'Oktober',
      november: 'November',
      december: 'Dezember'
    },
  
    // Hero Section
    hero: {
      badge: {
        madeInEu: 'Made in EU',
        privateSecure: '100% Privat'
      },
      headline: 'Professionelle Lebensläufe für Ihren nächsten Karrieresprung',
      highlightWord: 'Professionelle Lebensläufe',
      subtitle: 'Beeindruckende Vorlagen. Mühelose Formatierung. Vollständiger Datenschutz. Erstelle deinen Lebenslauf direkt im Browser – ganz ohne Anmeldung oder Abo.',
      features: {
        alwaysPrivate: '100 % privat',
        readyInMinutes: 'In Minuten bereit',
        beautifulTemplates: 'Elegante Vorlagen'
      },
      cta: {
        primary: 'Lebenslauf erstellen',
        secondary: 'So geht\'s'
      }
    },
  
    // Features Section
    features: {
      sectionTitle: 'DIE KLARE WAHL',
      title: 'Warum privacv?',
      subtitle: 'Der smarte CV-Builder – privat, schnell und fair.',
  
      advantages: {
        payPerUse: {
          title: 'Zahlen pro Nutzung',
          privacv: 'Ab 0,99 € – keine Abos',
          others: '15–50 € monatliche Abos',
          highlight: 'Mehrere Optionen: Einmalzahlung oder Zeitpässe'
        },
        zeroDataCollection: {
          title: 'Keine Datensammlung',
          privacv: 'Daten bleiben in Ihrem Browser',
          others: 'Sammelt und speichert persönliche Daten',
          highlight: 'Ihre Daten können nicht missbraucht werden'
        },
        instantAccess: {
          title: 'Sofortiger Zugang',
          privacv: 'Sofort loslegen',
          others: 'E‑Mail‑Bestätigung und Freischaltung',
          highlight: 'Keine Anmeldehürden oder Wartezeiten'
        },
        noRegistration: {
          title: 'Keine Registrierung',
          privacv: 'Vollständig anonym',
          others: 'Konto zwingend erforderlich',
          highlight: 'Keine Passwörter oder Profile'
        }
      },
  
      additionalBenefits: {
        title: 'Mehr als nur die Grundlagen – weitere Vorteile',
        professionalQuality: {
          title: 'Professionelle Qualität',
          description: 'ATS‑optimierte Vorlagen, von Experten entwickelt',
          value: 'Überzeugen Sie Personaler und bestehen Sie automatisierte Prüfungen'
        },
        fullFeatureAccess: {
          title: 'Vollzugriff auf alle Features',
          description: 'Alles von Tag eins freigeschaltet',
          value: 'Keine Premium‑Stufen oder Einschränkungen'
        },
        offlineCapable: {
          title: 'Offline verfügbar',
          description: 'Funktioniert auch ohne Internetverbindung',
          value: 'Erstellen Sie Ihren Lebenslauf überall und jederzeit'
        },
        noVendorLockIn: {
          title: 'Keine Anbieterbindung',
          description: 'Exportieren Sie Ihre Daten jederzeit',
          value: 'Volle Kontrolle über Ihre Informationen'
        },
        gdprCompliant: {
          title: 'DSGVO‑konform',
          description: 'Privacy‑by‑Design‑Architektur',
          value: 'Rechtssicherheit ohne Komplexität'
              },
      noSpamEver: {
        title: 'Garantiert spamfrei',
        description: 'Keine Marketing‑E‑Mails oder Tracking',
        value: 'Ungestörtes, fokussiertes Arbeiten'
      }
    }
  },
  
    // How It Works Section
    howItWorks: {
      title: 'So einfach geht\'s',
      subtitle: 'Erstellen Sie einen professionellen Lebenslauf in nur 3 einfachen Schritten.',
      steps: {
        addInfo: {
          title: 'Daten eingeben',
          description: 'Tragen Sie Ihre Informationen ein oder importieren Sie sie von LinkedIn, PDF oder DOCX.'
        },
        chooseStyle: {
          title: 'Design wählen',
          description: 'Wählen Sie aus professionellen Vorlagen und passen Sie diese an Ihren Stil an.'
        },
        download: {
          title: 'Herunterladen & bewerben',
          description: 'Exportieren Sie Ihren perfekten Lebenslauf und bewerben Sie sich erfolgreich.'
        }
      },
      cta: {
        title: 'Bereit zum Durchstarten?',
        subtitle: 'Schließen Sie sich Tausenden von Fachkräften an, die bereits ihren perfekten Lebenslauf erstellt haben',
        button: 'Lebenslauf erstellen'
      },
      hint: {
        title: 'Profi-Tipp:',
        description: 'Laden Sie die kostenlose CV-Speicherdatei herunter, um jederzeit dort weiterzumachen, wo Sie aufgehört haben'
      }
    },
  
    // Templates Section
    templates: {
      title: 'Professionelle Vorlagen nach Branche',
      subtitle: 'Entdecken Sie 25 sorgfältig kuratierte Vorlagen für jede Branche und jeden Stil. Jedes Design wurde entwickelt, um genau die Fähigkeiten und Erfahrungen hervorzuheben, die in Ihrem Beruf am wichtigsten sind.',
      stats: {
        templates: 'Vorlagen',
        customization: 'Anpassbarkeit',
        industries: 'Branchen',
        atsCompatible: 'ATS‑kompatibel'
      },
      popular: 'Beliebt',
      useTemplate: 'Vorlage nutzen',
      descriptions: {
        softwareEngineer: 'Moderne Tech‑Vorlage ideal für Entwickler, Programmierer und IT‑Fachkräfte',
        accountExecutive: 'Executive‑fokussierte Topbar‑Vorlage, perfekt für Senior Sales und Business Development',
        healthcareProfessional: 'Klares, vertrauensvolles Design – ideal für medizinische Fachkräfte, Pflegekräfte und Gesundheitsmanager',
        marketingSpecialist: 'Kreatives geometrisches Design – perfekt für Marketing‑, Werbe‑ und Brand‑Profis',
        environmentalScientist: 'Moderne Topbar‑Vorlage, ideal für Nachhaltigkeitsberater und Umweltexperten',
        financialAdvisor: 'Konservatives, professionelles Design für Banking‑, Finanz‑ und Investment‑Profis',
        civilEngineer: 'Technisches, präzises Design – ideal für Ingenieure, Architekten und technische Fachkräfte',
        managementConsultant: 'Klare Topbar‑Vorlage mit hellem Design – perfekt für Beratung und strategische Rollen',
        legalCounsel: 'Traditionelle, autoritative Vorlage für Anwälte, Rechtsanwaltsfachangestellte und Juristen',
        creativeDirector: 'Mutiges, künstlerisches Design für Designer, Künstler und Kreativ‑Profis',
        educationLeader: 'Wissenschaftlich klares Design für Lehrkräfte, Professoren und Bildungsmanager',
        salesExecutive: 'Dynamische, überzeugende Vorlage für Vertriebsprofis und Account Manager',
        corporateExecutive: 'Professionelle Topbar‑Vorlage – ideal für C‑Suite‑Führungskräfte und Senior Corporate Leadership',
        hrSpecialist: 'Warmes, zugängliches Design – ideal für HR‑ und People‑Operations‑Profis',
        businessConsultant: 'Beratungs‑Vorlage mit strukturierter Timeline für strategische Rollen',
        productManager: 'Moderne Topbar‑Vorlage, perfekt für Produktmanager und Innovation Leader',
        operationsManager: 'Organisiertes, effizientes Layout – ideal für Operations‑, Logistik‑ und Management‑Rollen',
        realEstateAgent: 'Vertrauensvolle, professionelle Vorlage für Immobilienmakler und Immobilien‑Profis',
        startupFounder: 'Mutiges, innovatives Template – perfekt für Unternehmer und Startup‑Profis',
        hospitalityManager: 'Einladendes, freundliches Design für Hospitality‑, Tourismus‑ und Kundenservice‑Profis',
        researchScientist: 'Klares, analytisches Design – ideal für Forscher, Wissenschaftler und Akademiker',
        retailManager: 'Helles, zugängliches Design – ideal für Einzelhandel, Kundenservice und kundenorientierte Rollen',
        nonprofitDirector: 'Mission‑getriebenes, mitfühlendes Design für Non‑Profit‑ und Social‑Impact‑Profis',
        projectManager: 'Strukturierte, organisierte Vorlage – ideal für Projektmanager und Prozessoptimierungs‑Rollen',
        executiveLeader: 'Premium, raffiniertes Design für C‑Suite‑Führungskräfte und Senior Leadership‑Positionen'
      },
      finalCta: {
        title: 'Ihre Branche nicht dabei? Kein Problem!',
        subtitle: 'Jede Vorlage ist vollständig anpassbar. Beginnen Sie mit einem beliebigen Design und machen Sie es zu Ihrem eigenen.',
        button: 'Alle Vorlagen entdecken'
      }
    },
  
    // Pricing Section
    pricing: {
      title: 'Einfach. Transparent. Fair.',
      subtitle: 'Kostenlos erstellen, nur beim Download zahlen. Keine Abos, keine versteckten Gebühren.',
      mostPopular: 'Beliebteste Wahl',
      price: '4,99€',
      priceSubtitle: 'Einmalig',
      features: {
        unlimitedResumes: 'Unbegrenzt Lebensläufe erstellen',
        allTemplates: 'Alle professionellen Vorlagen',
        privacyProtection: 'Vollständiger Datenschutz',
        atsOptimized: 'ATS‑optimiertes Design',
        noSignup: 'Keine Anmeldung, keine Kreditkarte zum Start',
        payPerDownload: 'Zahlen Sie nur beim PDF-Download'
      },
      cta: 'Jetzt erstellen',
      passFeatures: {
        singleDownload: 'Einzelner PDF-Download',
        unlimitedDownloads24h: 'Unbegrenzte Downloads für 24 Stunden',
        unlimitedDownloads7d: 'Unbegrenzte Downloads für 7 Tage',
        unlimitedDownloads30d: 'Unbegrenzte Downloads für 30 Tage',
        allTemplates: 'Alle professionellen Vorlagen',
        fullCustomization: 'Vollständige Anpassungsoptionen',
        perfectForSingle: 'Perfekt für eine Bewerbung',
        greatForRevisions: 'Ideal für schnelle Überarbeitungen',
        perfectForJobHunt: 'Perfekt für aktive Jobsuche',
        bestValue: 'Bestes Preis-Leistungs-Verhältnis'
      },
      whyTimeLimited: {
        title: 'Warum zeitbegrenzte Pässe statt Abonnements?',
        description: 'Jobsuche ist intensiv aber zeitlich begrenzt. Unsere Pässe geben Ihnen unbegrenzte Downloads während Ihrer aktiven Suchphase und enden dann automatisch—keine wiederkehrenden Gebühren, keine vergessenen Abos. Wählen Sie die Dauer, die zu Ihrem Zeitplan passt.'
      }
    },
  
    // FAQ Section
    faq: {
      title: 'Häufig gestellte Fragen',
      subtitle: 'Alles, was Sie über privacv wissen müssen. Können Sie nicht finden, wonach Sie suchen? Probieren Sie einfach die App aus!',
      showMore: 'Mehr Fragen anzeigen',
      showLess: 'Weniger anzeigen',
      questions: {
        howMuchCost: {
          question: 'Was kostet privacv?',
          answer: 'privacv ist kostenlos zum Erstellen und Bearbeiten Ihres Lebenslaufs. Sie zahlen nur 4,99€ wenn Sie Ihr PDF herunterladen möchten. Keine Abonnements, keine monatlichen Gebühren, keine versteckten Kosten. Erstellen Sie unbegrenzt Lebensläufe und zahlen Sie nur wenn Sie die professionelle PDF-Ausgabe brauchen.'
        },
        howProtectPrivacy: {
          question: 'Wie schützt Privacv meine Privatsphäre?',
          answer: 'Ihre Daten verlassen niemals Ihren Browser. Alles wird lokal auf Ihrem Gerät verarbeitet – das bedeutet, wir sehen, speichern oder verfolgen niemals Ihre persönlichen Informationen. Keine Konten erforderlich, keine Daten gesammelt, keine Tracking‑Cookies.'
        },
        atsFriendly: {
          question: 'Sind die Lebensläufe ATS‑kompatibel?',
          answer: 'Absolut! Alle unsere Vorlagen sind speziell für ATS (Applicant Tracking Systems) optimiert. Sie nutzen eine korrekte Formatierung, Standard‑Schriften und klare Strukturen, die ATS‑Systeme problemlos lesen und verstehen können.'
        },
        canImport: {
          question: 'Kann ich meinen bestehenden Lebenslauf oder LinkedIn‑Daten importieren?',
          answer: 'Ja! Sie können Daten aus verschiedenen Quellen importieren: LinkedIn‑Profile (ZIP‑Export) sowie bestehende Lebensläufe als PDF oder DOCX. Unser intelligenter Parser extrahiert die Informationen und befüllt Ihren neuen Lebenslauf automatisch.'
        },
        exportFormats: {
          question: 'In welchen Formaten kann ich exportieren?',
          answer: 'Sie können Ihren Lebenslauf als hochwertiges PDF für 4,99€ exportieren, perfekt für Bewerbungen mit professioneller Formatierung. Sie können Ihre Daten auch kostenlos als JSON sichern, um später weiter zu bearbeiten.'
        },
        needAccount: {
          question: 'Muss ich ein Konto erstellen?',
          answer: 'Nein! Sie können sofort mit der Erstellung beginnen – ohne Registrierung, Passwörter oder persönliche Angaben. Einfach die Seite öffnen und loslegen.'
        },
        mobileDevices: {
          question: 'Funktioniert Privacv auf mobilen Geräten?',
          answer: 'Ja! Privacv ist vollständig responsiv und funktioniert perfekt auf allen Geräten – Smartphones, Tablets und Desktop. Sie können Ihren Lebenslauf unterwegs mit denselben Features wie am Computer erstellen und bearbeiten.'
        },
        howManyResumes: {
          question: 'Wie viele Lebensläufe kann ich erstellen?',
          answer: 'Sie können unbegrenzt Lebensläufe kostenlos erstellen! Erstellen Sie so viele, wie Sie brauchen – für verschiedene Stellen, Branchen oder Karrierestufen. Jeder Lebenslauf kann individuell mit unterschiedlichen Vorlagen und Inhalten angepasst werden. Sie zahlen nur beim PDF-Download.'
        },
        canCustomize: {
          question: 'Kann ich die Vorlagen anpassen?',
          answer: 'Selbstverständlich! Passen Sie Farben, Schriften, Layouts und Abschnitte an Ihren persönlichen Stil und Branchenanforderungen an. Alle Vorlagen sind vollständig anpassbar und behalten dabei ihr professionelles Erscheinungsbild.'
        },
        needHelp: {
          question: 'Was, wenn ich Hilfe brauche?',
          answer: 'Privacv ist intuitiv und benutzerfreundlich gestaltet. Zusätzlich bieten wir umfassende Anleitungen und Tipps direkt in der Anwendung. Die Benutzeroberfläche enthält hilfreiche Hinweise und Best Practices für jeden Bereich.'
        }
      },
      finalCta: {
        title: 'Noch Fragen?',
        subtitle: 'Am besten probieren Sie privacv einfach selbst aus. Starten Sie kostenlos und sehen Sie, wie einfach es ist!'
      }
    },
  
    // Testimonials Section
    testimonials: {
      title: 'Geschätzt von Profis',
      subtitle: 'Schließen Sie sich Tausenden von Fachkräften an, die mit Privacv erfolgreich ihren Traumjob gefunden haben',
      stats: {
        resumesCreated: 'Lebensläufe erstellt',
        averageRating: 'Durchschnittsbewertung',
        successRate: 'Erfolgsquote'
      },
      quotes: {
        sarahJohnson: 'Privacv hat mir dabei geholfen, meinen Traumjob zu bekommen. Der Privacy‑First‑Ansatz gab mir ein beruhigendes Gefühl.',
        michaelChen: 'Der beste Lebenslauf‑Builder, den ich je genutzt habe. Saubere Oberfläche, elegante Vorlagen und kein Daten‑Tracking. Absolut empfehlenswert!',
        emilyRodriguez: 'Als Designerin schätze ich die Detailliebe in den Vorlagen. Die Anpassungsmöglichkeiten sind grenzenlos.',
        davidKim: 'Meinen Lebenslauf in unter 30 Minuten fertiggestellt. Die ATS‑Optimierung hat mir geholfen, die erste Hürde zu nehmen.',
        lisaThompson: 'Der Datenschutz‑Aspekt hat mich überzeugt. Keine Konten, kein Tracking – nur ein großartiges Tool, das meine Daten respektiert.',
        jamesWilson: 'Profil importiert und in Minuten einen perfekten Lebenslauf erstellt. Absoluter Gamechanger!'
      }
    },
  
    // Footer Section
    footer: {
      getStarted: 'Jetzt starten',
      legal: {
        impressum: 'Impressum',
        terms: 'Nutzungsbedingungen',
        privacy: 'Datenschutzerklärung'
      },
      tagline: 'Erstellen Sie Ihren perfekten Lebenslauf mit vollständiger Privatsphäre',
      description: 'Der Privacy‑First‑Lebenslauf‑Builder, der Ihnen hilft, professionelle Lebensläufe zu erstellen – ohne Kompromisse bei Ihren persönlichen Daten. Von Profis für Profis entwickelt.',
      features: {
        privateSecure: '100 % privat',
        readyInMinutes: 'In Minuten bereit',
        professionalTemplates: 'Professionelle Vorlagen'
      },
      madeWith: 'Entwickelt mit',
      forJobSeekers: 'für Jobsuchende weltweit',
      copyright: 'Privacv. Privacy by Design. Keine Datensammlung, kein Tracking.',
      cta: {
        title: 'Bereit für Ihren professionellen Lebenslauf?',
        subtitle: 'Schließen Sie sich Tausenden von Fachkräften an, die privacv vertrauen',
        button: 'Jetzt erstellen'
      }
    },
  
      // Language Selection
  language: {
    select: 'Sprache wählen',
    english: 'English',
    german: 'Deutsch',
    french: 'Français'
  },

  // Welcome Screen
  welcome: {
    title: 'Erstellen wir Ihren Lebenslauf',
    subtitle: 'Wählen Sie, wie Sie beginnen möchten. Sie können vorhandene Daten importieren oder von Grund auf neu anfangen.',
    trustIndicators: {
      private: '100% Privat',
      fast: 'In Minuten fertig'
    },
    startFromScratch: {
      title: 'Von Grund auf beginnen',
      description: 'Geben Sie Ihre Informationen manuell mit unserem geführten Formular ein. Perfekt für die Erstellung eines neuen, benutzerdefinierten Lebenslaufs.',
      getStarted: 'Loslegen'
    },
    orImport: 'ODER VORHANDENE DATEN IMPORTIEREN',
    importOptions: {
      title: 'Import-Optionen',
      linkedin: {
        title: 'Von LinkedIn importieren',
        description: 'Laden Sie Ihren LinkedIn-Datenexport hoch (ZIP-Datei)',
        badge: 'Beliebt',
        howToTitle: 'So erhalten Sie Ihre LinkedIn-Daten:',
        step1: 'Gehen Sie zu LinkedIn Einstellungen & Datenschutz.',
        step2: 'Klicken Sie auf "Datenschutz" → "Kopie Ihrer Daten".',
        step3: 'Wählen Sie die erste Option.',
        step4: 'Laden Sie die ZIP-Datei herunter, die Sie per Email von LinkedIn erhalten und laden Sie sie hier hoch.',
        uploadButton: 'ZIP-Datei hochladen',
        openLinkedIn: 'LinkedIn öffnen'
      },
      personas: {
        title: 'Beispiele vorladen',
        description: 'Wählen Sie aus professionellen CV-Vorlagen verschiedener Branchen',
        badge: 'Beliebt'
      },
      json: {
        title: 'Vorherigen Lebenslauf importieren',
        description: 'Laden Sie einen zuvor gespeicherten Lebenslauf (JSON-Datei)'
      },
      docx: {
        title: 'Word-Dokument importieren',
        description: 'Laden Sie einen vorhandenen Lebenslauf hoch (DOCX-Datei) - Verbesserte Analyse mit Strukturerkennung',
        badge: 'Bald verfügbar'
      },
      pdf: {
        title: 'PDF-Lebenslauf importieren',
        description: 'Text aus einem PDF-Lebenslauf extrahieren - Verbesserte layoutbewusste Analyse',
        badge: 'Bald verfügbar'
      }
    },
    processing: {
      title: 'Ihre Daten werden verarbeitet...',
      subtitle: 'Dies kann einen Moment dauern'
    },
    tip: 'LinkedIn-Exporte bieten die umfassendsten Daten. Sie können Ihre LinkedIn-Daten unter Einstellungen & Datenschutz → Datenschutz → Kopie Ihrer Daten herunterladen.'
  },

  // Input Section
  input: {
    backToStart: 'Zurück zum Start',
    buildingResume: 'Lebenslauf erstellen',
    addSections: 'Abschnitte hinzufügen'
  },

  // Settings Panel specific translations
  settingsPanel: {
    tabs: {
      templates: 'Vorlagen',
      layout: 'Layout',
      design: 'Design',
      typography: 'Typografie'
    },
    templates: {
      title: 'Vorlage auswählen',
      deleteConfirm: 'Sind Sie sicher, dass Sie die Vorlage löschen möchten',
      noPreview: 'Keine Vorschau'
    },
    layout: {
      categories: {
        classic: 'Klassisch',
        'classic centered timeline': 'Klassische zentrierte Zeitleiste',
        'sidebar right classic': 'Seitenleiste rechts klassisch',
        'sidebar left classic': 'Seitenleiste links klassisch',
        'sidebar right modern': 'Seitenleiste rechts modern',
        'sidebar left modern': 'Seitenleiste links modern',
        'topbar classic': 'Kopfleiste klassisch',
        'topbar modern': 'Kopfleiste modern',
        tech: 'Tech',
        triangular: 'Dreieckig',
        geometric: 'Geometrisch',
        other: 'Andere'
      }
    },
    design: {
      colorSchemes: 'Farbschemata',
      categories: {
        default: 'Standard',
        professional: 'Professionell',
        tech: 'Tech',
        other: 'Andere',
        custom: 'Benutzerdefiniert'
      },
      customControls: 'Anpassungssteuerung',
      baseDesign: 'Basis-Design',
      editColors: 'Farben bearbeiten',
      saveScheme: 'Aktuelles Schema speichern',
      schemeName: 'Schema-Name',
      savedSchemes: 'Gespeicherte benutzerdefinierte Schemata',
      load: 'Laden',
      editCustom: 'Benutzerdefiniert bearbeiten'
    },
    background: {
      title: 'Seitenhintergrund-Effekt'
    },
    barStyle: {
      title: 'Kenntnisstufen-Anzeige-Stil'
    },
    specialEffects: {
      title: 'Spezialeffekte'
    },
    style: {
      title: 'Erscheinungsbild-Stil'
    },
    typography: {
      reset: 'Zurücksetzen',
      sections: {
        cvTitle: 'CV-Titel (Name)',
        sectionTitle: 'Abschnittstitel',
        body: 'Fließtext',
        smallText: 'Kleiner Text (Daten, etc.)'
      },
      fields: {
        size: 'Größe (pt)',
        spacing: 'Abstand',
        fontFamily: 'Schriftart'
      }
    }
  },

  // Image Cropper
  imageCropper: {
    title: 'Profilbild zuschneiden',
    instruction: 'Ziehen Sie, um Ihr Bild im Kreis zu positionieren',
    zoom: 'Zoom',
    reposition: 'Ziehen zum Neupositionieren',
    processing: 'Verarbeitung...',
    error: 'Fehler beim Zuschneiden des Bildes. Bitte versuchen Sie es erneut.',
    failedToLoad: 'Fehler beim Laden des Bildes. Bitte versuchen Sie es mit einer anderen Datei.',
    sizeTooLarge: 'Bitte wählen Sie ein Bild kleiner als',
    invalidFile: 'Bitte wählen Sie eine gültige Bilddatei.'
  },

  // Generic messages
  messages: {
    noItemsAvailable: 'Keine Elemente verfügbar.',
    noBackgroundsAvailable: 'Keine Hintergründe verfügbar.',
    noBarStylesAvailable: 'Keine Balken-Stile verfügbar.',
    noSpecialEffectsAvailable: 'Keine Spezialeffekte verfügbar.',
    noStylesAvailable: 'Keine Stile verfügbar.'
  },

  // Special effects
  specialEffects: {
    'None': 'Keine',
    'Timeline Effect': 'Zeitleisten-Effekt',
  },

  // Special effect descriptions
  specialEffectDescriptions: {
    'No special visual effects applied.': 'Keine besonderen visuellen Effekte angewendet.',
    'Adds a visual timeline connecting dated sections.': 'Fügt eine visuelle Zeitleiste hinzu, die datierte Abschnitte verbindet.',
  },

  // Design color names
  designNames: {
    'Default Black': 'Standard Schwarz',
    'Default Gray': 'Standard Grau',
    'Blue': 'Blau',
    'Green': 'Grün',
    'Orange': 'Orange',
    'Colorful': 'Bunt',
    'Social': 'Social',
    'Yellow': 'Lebendiges Gelb', // Backward compatibility
    'Vibrant Yellow': 'Lebendiges Gelb',
    'Navy': 'Marine',
    'Charcoal': 'Anthrazit',
    'Beige': 'Beige',
    'Olive': 'Oliv',
    'Teal': 'Blaugrün',
    'Burgundy': 'Burgunder',
  },

  // Payment Modal
  payment: {
    modal: {
      title: 'PDF Download',
      subtitle: 'Wählen Sie Ihre Option',
      chooseOption: 'Wählen Sie Ihre Zahlungsoption',
      tabs: {
        code: 'Code eingeben',
        purchase: 'Neuer Kauf'
      },
      explanatoryText: 'Zeitbegrenzte Pässe ermöglichen unbegrenzte Downloads während ihrer Gültigkeitsdauer.',
      securePayment: 'Sichere Zahlung',
      redirectMessage: 'Sie werden zu Stripes sicherem Checkout weitergeleitet, um Ihre Zahlung abzuschließen',
      securityNotice: 'Gesichert durch Stripe • Ihre Zahlungsinformationen sind verschlüsselt',
      cancel: 'Abbrechen',
      cancelButton: 'Abbrechen',
      proceedButton: 'Zur Zahlung',
      redirecting: 'Weiterleitung...',
      error: 'Bitte wählen Sie eine Zahlungsoption aus.',
      selectOption: 'Wählen Sie eine Option, um fortzufahren'
    },
    tabs: {
      existingCustomer: 'Download-Schlüssel eingeben',
      newPurchase: 'Neuer Kauf'
    },
    codeInput: {
      title: 'Download-Schlüssel eingeben',
      description: 'Haben Sie einen Download-Schlüssel? Geben Sie ihn unten ein',
      placeholder: 'Download-Schlüssel eingeben',
      submit: 'Schlüssel prüfen',
      verifying: 'Prüfung läuft...',
      hint: 'Download-Schlüssel werden mit 24h-, Wochen- und Monatspässen bereitgestellt',
      errors: {
        invalid: 'Ungültiges Download-Schlüssel-Format',
        expired: 'Dieser Download-Schlüssel ist abgelaufen',
        notFound: 'Download-Schlüssel nicht gefunden',
        generic: 'Überprüfung des Download-Schlüssels fehlgeschlagen'
      }
    },
    products: {
      pdf_one_time: {
        name: 'Einmaliger Download',
        description: 'Einzelner PDF-Export'
      },
      pdf_24h: {
        name: '24-Stunden-Pass',
        description: 'Unbegrenzte Downloads für 24h'
      },
      pdf_week: {
        name: 'Wochen-Pass',
        description: 'Unbegrenzte Downloads für 7 Tage'
      },
      pdf_month: {
        name: 'Monats-Pass',
        description: 'Unbegrenzte Downloads für 30 Tage'
      }
    },
    option: {
      emailDelivery: 'Download-Schlüssel per E-Mail'
    },
    errors: {
      failedToCreate: 'Checkout-Sitzung konnte nicht erstellt werden',
      stripeNotConfigured: 'Stripe nicht konfiguriert',
      paymentFailed: 'Zahlung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      noProductSelected: 'Bitte wählen Sie eine Zahlungsoption, um fortzufahren.'
    }
  },

  // Legal Pages
  legal: {
    // Common elements
    common: {
      lastUpdated: 'Stand: {date}',
      backButton: 'Zurück',
      contactEmail: 'info@privacv.com',
      companyName: 'Navid Sadat-Razavi',
      companyAddress: 'Kopischstr. 1',
      companyCity: '10965 Berlin',
      companyCountry: 'Deutschland',
      pdfPrice: '€4,99',
              pdfPriceRange: '€0,99-7,99',
      currency: '€',
      websiteUrl: 'privacv.de'
    },

    // Privacy Policy
    privacy: {
      title: 'Datenschutzerklärung',
      sections: {
        overview: {
          title: '1. Datenschutz auf einen Blick',
          generalInfo: {
            title: 'Allgemeine Hinweise',
            content: 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.'
          },
          dataCollection: {
            title: 'Datenerfassung auf dieser Website',
            whoResponsible: {
              question: 'Wer ist verantwortlich für die Datenerfassung auf dieser Website?',
              answer: 'Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.'
            },
            howCollect: {
              question: 'Wie erfassen wir Ihre Daten?',
              answer: 'Ihre Daten werden zum einen dadurch erhoben, dass Sie uns diese mitteilen. Hierbei kann es sich z.B. um Daten handeln, die Sie in ein Kontaktformular eingeben. Andere Daten werden automatisch beim Besuch der Website durch unsere IT-Systeme erfasst. Das sind vor allem technische Daten (z.B. Internetbrowser, Betriebssystem oder Uhrzeit des Seitenaufrufs).'
            },
            whatFor: {
              question: 'Wofür nutzen wir Ihre Daten?',
              answer: 'Ein Teil der Daten wird erhoben, um eine fehlerfreie Bereitstellung der Website zu gewährleisten. Andere Daten können zur Analyse Ihres Nutzerverhaltens verwendet werden.'
            },
            yourRights: {
              question: 'Welche Rechte haben Sie bezüglich Ihrer Daten?',
              answer: 'Sie haben jederzeit das Recht unentgeltlich Auskunft über Herkunft, Empfänger und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.'
            }
          }
        },
        hosting: {
          title: '2. Hosting und Content Delivery Networks (CDN)',
          externalHosting: {
            title: 'Externes Hosting',
            content: 'Diese Website wird bei einem externen Dienstleister gehostet (Hoster). Die personenbezogenen Daten, die auf dieser Website erfasst werden, werden auf den Servern des Hosters gespeichert. Hierbei kann es sich v. a. um IP-Adressen, Kontaktanfragen, Meta- und Kommunikationsdaten, Vertragsdaten, Kontaktdaten, Namen, Websitezugriffe und sonstige Daten, die über eine Website generiert werden, handeln.\n\nDas externe Hosting erfolgt zum Zwecke der Vertragserfüllung gegenüber unseren potenziellen und bestehenden Kunden (Art. 6 Abs. 1 lit. b DSGVO) und im Interesse einer sicheren, schnellen und effizienten Bereitstellung unseres Online-Angebots durch einen professionellen Anbieter (Art. 6 Abs. 1 lit. f DSGVO).'
          }
        },
        generalInfo: {
          title: '3. Allgemeine Hinweise und Pflichtinformationen',
          dataProtection: {
            title: 'Datenschutz',
            content: 'Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend der gesetzlichen Datenschutzbestimmungen sowie dieser Datenschutzerklärung.'
          },
          responsibleParty: {
            title: 'Hinweis zur verantwortlichen Stelle',
            content: 'Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:\n\n{companyName}\n{companyAddress}\n{companyCity}\n{companyCountry}\n\nE-Mail: {contactEmail}'
          },
          revocation: {
            title: 'Widerruf Ihrer Einwilligung zur Datenverarbeitung',
            content: 'Viele Datenverarbeitungsvorgänge sind nur mit Ihrer ausdrücklichen Einwilligung möglich. Sie können eine bereits erteilte Einwilligung jederzeit widerrufen. Dazu reicht eine formlose Mitteilung per E-Mail an uns. Die Rechtmäßigkeit der bis zum Widerruf erfolgten Datenverarbeitung bleibt vom Widerruf unberührt.'
          },
          complaint: {
            title: 'Beschwerderecht bei der zuständigen Aufsichtsbehörde',
            content: 'Im Falle von Verstößen gegen die DSGVO steht den Betroffenen ein Beschwerderecht bei einer Aufsichtsbehörde, insbesondere in dem Mitgliedstaat ihres gewöhnlichen Aufenthalts, ihres Arbeitsplatzes oder des Orts des mutmaßlichen Verstoßes zu. Das Beschwerderecht besteht unbeschadet anderweitiger verwaltungsrechtlicher oder gerichtlicher Rechtsbehelfe.'
          },
          portability: {
            title: 'Recht auf Datenübertragbarkeit',
            content: 'Sie haben das Recht, Daten, die wir auf Grundlage Ihrer Einwilligung oder in Erfüllung eines Vertrags automatisiert verarbeiten, an sich oder an einen Dritten in einem gängigen, maschinenlesbaren Format aushändigen zu lassen. Sofern Sie die direkte Übertragung der Daten an einen anderen Verantwortlichen verlangen, erfolgt dies nur, soweit es technisch machbar ist.'
          }
        },
        dataCollection: {
          title: '4. Datenerfassung auf dieser Website',
          cookies: {
            title: 'Cookies',
            content: 'Unsere Internetseiten verwenden so genannte "Cookies". Cookies sind kleine Textdateien und richten auf Ihrem Endgerät keinen Schaden an. Sie werden entweder vorübergehend für die Dauer einer Sitzung (Session-Cookies) oder dauerhaft (permanente Cookies) auf Ihrem Endgerät gespeichert.'
          },
          serverLogs: {
            title: 'Server-Log-Dateien',
            content: 'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. Dies sind:\n\n• Browsertyp und Browserversion\n• verwendetes Betriebssystem\n• Referrer URL\n• Hostname des zugreifenden Rechners\n• Uhrzeit der Serveranfrage\n• IP-Adresse\n\nEine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Die Erfassung dieser Daten erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO. Der Websitebetreiber hat ein berechtigtes Interesse an der technisch fehlerfreien Darstellung und der Optimierung seiner Website – hierzu müssen die Server-Log-Files erfasst werden.'
          },
          localStorage: {
            title: 'Lokale Datenspeicherung',
            content: 'privacv ist eine Privacy-First-Anwendung, die alle Datenverarbeitung lokal in Ihrem Browser durchführt. Das bedeutet:\n\n• Ihre Lebenslaufdaten werden nur im lokalen Speicher Ihres Browsers gespeichert\n• Keine Datenübertragung an unsere Server beim Erstellen und Bearbeiten\n• Sie haben vollständige Kontrolle über Ihre Daten\n• Daten können jederzeit durch Löschen des Browser-Speichers entfernt werden'
          },
          stripePayment: {
            title: 'Zahlungsverarbeitung mit Stripe',
            content: 'Für unseren zeitbegrenzten Pass-Service nutzen wir Stripe als Zahlungsdienstleister. Bei einer Zahlung werden folgende Daten an Stripe übertragen:\n\n• Zahlungsinformationen (Kreditkarte, etc.)\n• Transaktionsbetrag ({pdfPriceRange})\n• Zeitstempel der Transaktion\n• Keine persönlichen Daten aus Ihrem Lebenslauf\n\n**Wichtig:** Ihre Lebenslaufdaten werden niemals an Stripe oder andere Drittanbieter übertragen. Nur die Zahlungsinformationen werden für die Transaktionsabwicklung verarbeitet.\n\n**Rechtsgrundlage:** Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. b DSGVO (Vertragserfüllung) zur Abwicklung der Zahlungstransaktion.\n\nWeitere Informationen zum Datenschutz bei Stripe finden Sie unter: https://stripe.com/privacy'
          },
          analytics: {
            title: 'Website-Analyse mit Umami',
            content: 'Diese Website nutzt Umami, einen datenschutzfreundlichen Webanalysedienst. Umami erfasst ausschließlich anonymisierte Nutzungsdaten, um die Websiteleistung zu analysieren und zu verbessern.\n\n**Erfasste Daten:**\n• Seitenaufrufe und Besucherzahlen\n• Verweisende Websites (Referrer)\n• Browser- und Geräteinformationen\n• Geografische Region (Land/Bundesland)\n• Besuchsdauer und Interaktionen\n\n**Datenschutz bei Umami:**\n• Keine Speicherung von IP-Adressen\n• Keine Cookies oder Tracking\n• Keine personenbezogenen Daten\n• Server-Standort: EU\n• DSGVO-konform\n\n**Rechtsgrundlage:** Die Datenverarbeitung erfolgt auf Grundlage von Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse) zur Analyse und Verbesserung unserer Website.\n\n**Opt-Out:** Sie können die Erfassung durch Umami jederzeit durch Aktivierung der "Do Not Track"-Einstellung in Ihrem Browser deaktivieren.\n\n**Technische Schutzmaßnahmen:** Umami verarbeitet Daten ausschließlich pseudonym, ohne websiteübergreifendes Tracking und mit automatischer Datenlöschung nach 24 Monaten. IP-Adressen werden gekürzt und es erfolgt keine Profilbildung für Werbezwecke.'
          }
        }
      }
    },

    // Terms of Service
    terms: {
      title: 'Nutzungsbedingungen',
      sections: {
        scope: {
          title: '1. Geltungsbereich',
          content: 'Diese Nutzungsbedingungen gelten für die Nutzung der Website {websiteUrl} und der darüber bereitgestellten Dienste. Mit der Nutzung der Website stimmen Sie diesen Bedingungen zu.'
        },
        serviceDescription: {
          title: '2. Beschreibung des Dienstes',
          content: 'privacv ist ein Online-Tool zur Erstellung von Lebensläufen, das vollständig im Browser des Nutzers arbeitet. Die Erstellung und Bearbeitung von Lebensläufen ist kostenlos. Zeitbegrenzte Pässe ({pdfPriceRange}) sind für PDF-Downloads verfügbar und ermöglichen unbegrenzte Downloads während der Gültigkeitsdauer. Alle Datenverarbeitung erfolgt lokal ohne Übertragung personenbezogener Daten an unsere Server, außer bei der Zahlungsabwicklung über Stripe.'
        },
        rightsAndPricing: {
          title: '3. Nutzungsrechte und Preise',
          content: 'Die Erstellung und Bearbeitung von Lebensläufen mit privacv ist kostenlos. Sie erhalten das nicht-ausschließliche Recht, den Dienst für private und geschäftliche Zwecke zu nutzen. Zeitbegrenzte Pässe ({pdfPriceRange}) sind für unbegrenzte PDF-Downloads während der Gültigkeitsdauer (24 Stunden, 7 Tage oder 30 Tage) verfügbar.\n\nDie Weiterverbreitung oder kommerzielle Nutzung der Website-Inhalte ist ohne ausdrückliche Genehmigung untersagt. Heruntergeladene PDFs können Sie frei für Bewerbungszwecke verwenden.'
        },
        paymentTerms: {
          title: '4. Zahlungsbedingungen',
          content: 'Die Zahlung für zeitbegrenzte Pässe erfolgt über unseren Zahlungsdienstleister Stripe. Pass-Preise ({pdfPriceRange}) werden sofort bei erfolgreicher Zahlung fällig. Nach erfolgreicher Zahlung stehen unbegrenzte PDF-Downloads für den gewählten Zeitraum zur Verfügung.\n\nAlle Preise verstehen sich inklusive der gesetzlichen Mehrwertsteuer. Pässe laufen automatisch nach ihrer Gültigkeitsdauer ab, ohne wiederkehrende Gebühren.'
        },
        userObligations: {
          title: '5. Pflichten des Nutzers',
          content: 'Der Nutzer verpflichtet sich, den Dienst nur zu rechtmäßigen Zwecken zu nutzen. Insbesondere ist es untersagt:\n\n• falsche oder irreführende Informationen in Lebensläufen einzutragen\n• den Dienst für illegale Aktivitäten zu nutzen\n• technische Schutzmaßnahmen zu umgehen\n• die Website zu überlasten oder zu beschädigen'
        },
        dataProtection: {
          title: '6. Datenschutz',
          content: 'Der Schutz Ihrer Daten hat für uns höchste Priorität. Alle Ihre Eingaben werden ausschließlich lokal in Ihrem Browser gespeichert und verarbeitet. Es findet keine Übertragung Ihrer persönlichen Daten an unsere Server statt, außer bei der Zahlungsabwicklung über Stripe, wo nur Zahlungsinformationen übertragen werden. Weitere Informationen finden Sie in unserer Datenschutzerklärung.'
        },
        availability: {
          title: '7. Verfügbarkeit des Dienstes',
          content: 'Wir bemühen uns um eine hohe Verfügbarkeit des Dienstes, können jedoch keine garantierte Verfügbarkeit zusichern. Wartungsarbeiten und technische Störungen können zu vorübergehenden Ausfällen führen.'
        },
        liability: {
          title: '8. Haftung',
          content: 'Die Nutzung von privacv erfolgt auf eigene Verantwortung. Wir haften nur für Schäden, die auf vorsätzliches oder grob fahrlässiges Verhalten unsererseits zurückzuführen sind. Die Haftung für mittelbare Schäden, entgangenen Gewinn oder Datenverlust ist ausgeschlossen, soweit gesetzlich zulässig.'
        },
        copyright: {
          title: '9. Urheberrecht',
          content: 'Alle Inhalte der Website, einschließlich Designs, Texte und Software, sind urheberrechtlich geschützt. Die Lebenslauf-Vorlagen dürfen ausschließlich für die Erstellung persönlicher Lebensläufe verwendet werden.'
        },
        changes: {
          title: '10. Änderungen der Nutzungsbedingungen',
          content: 'Wir behalten uns das Recht vor, diese Nutzungsbedingungen jederzeit zu ändern. Änderungen werden auf der Website veröffentlicht und treten mit der Veröffentlichung in Kraft.'
        },
        finalProvisions: {
          title: '11. Schlussbestimmungen',
          content: 'Es gilt deutsches Recht unter Ausschluss des UN-Kaufrechts. Gerichtsstand ist der Sitz unseres Unternehmens. Sollten einzelne Bestimmungen dieser Nutzungsbedingungen unwirksam sein, berührt dies nicht die Wirksamkeit der übrigen Bestimmungen.'
        }
      }
    },

    // Imprint
    imprint: {
      title: 'Impressum',
      sections: {
        tmgInfo: {
          title: 'Angaben gemäß § 5 TMG',
          content: '{companyName}\n{companyAddress}\n{companyCity}\n{companyCountry}'
        },
        contact: {
          title: 'Kontakt',
          content: 'E-Mail: {contactEmail}'
        },
        responsibleContent: {
          title: 'Verantwortlich für den Inhalt nach § 55 Abs. 2 RStV',
          content: '{companyName}\n{companyAddress}\n{companyCity}'
        },
        contentLiability: {
          title: 'Haftung für Inhalte',
          content: 'Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch nicht unter der Verpflichtung, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.\n\nVerpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.'
        },
        linkLiability: {
          title: 'Haftung für Links',
          content: 'Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.\n\nEine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links umgehend entfernen.'
        },
        copyright: {
          title: 'Urheberrecht',
          content: 'Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.\n\nSoweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.'
        },
        disputeResolution: {
          title: 'Hinweise zur öffentlichen Streitbeilegung',
          content: 'Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: https://ec.europa.eu/consumers/odr/\n\nUnsere E-Mail-Adresse finden Sie oben im Impressum.\n\nWir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.\n\n**Informationen gemäß § 36 VSBG**\n\nGemäß § 36 VSBG (Verbraucherstreitbeilegungsgesetz – Gesetz über die alternative Streitbeilegung in Verbrauchersachen) informieren wir Sie darüber, dass wir zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle weder bereit noch verpflichtet sind.\n\nSollten Sie dennoch Interesse an einer außergerichtlichen Streitbeilegung haben, können Sie sich an eine der Allgemeinen Verbraucherschlichtungsstellen wenden, beispielsweise:\n\nAllgemeine Verbraucherschlichtungsstelle des Zentrums für Schlichtung e.V.\nStraßburger Straße 8\n77694 Kehl am Rhein\nInternet: www.verbraucher-schlichter.de'
        }
      }
    }
  },

  // Email Templates
  email: {
    downloadKey: {
      subject: 'Ihr privacv Download-Schlüssel',
      title: 'Vielen Dank für Ihren Kauf!',
      subtitle: {
        '24h': 'Ihr 24-Stunden-Pass ist bereit',
        '7d': 'Ihr 7-Tage-Pass ist bereit', 
        '30d': 'Ihr 30-Tage-Pass ist bereit'
      },
      sections: {
        personalKey: {
          title: 'Ihr persönlicher Download-Schlüssel',
          description: 'Wir haben einen sicheren Download-Schlüssel für Ihren privacv-Pass generiert. Dieser Ansatz gewährleistet Ihre Privatsphäre, indem Ihre Lebenslaufdaten auf Ihrem Gerät bleiben und gleichzeitig unbegrenzte Downloads während der Pass-Gültigkeitsdauer ermöglicht werden.'
        },
        keyContainer: {
          label: 'Ihr Download-Schlüssel:',
          copyButton: 'Schlüssel kopieren',
          selectButton: 'Text auswählen',
          tip: '💡 Tipp: Sie können den Schlüssel auch manuell auswählen und kopieren'
        },
        instructions: {
          title: 'So verwenden Sie Ihren Download-Schlüssel:',
          steps: [
            'Gehen Sie zurück zu <strong>privacv.de</strong>',
            'Klicken Sie auf <strong>"PDF exportieren"</strong> → <strong>"Download-Schlüssel eingeben"</strong>',
            'Fügen Sie Ihren Download-Schlüssel ein und klicken Sie auf <strong>"Prüfen"</strong>',
            'Laden Sie Ihren professionellen Lebenslauf so oft wie nötig herunter!'
          ]
        },
        whyKeys: {
          title: 'Warum senden wir Ihnen Schlüssel?',
          description: 'Ihre Lebenslaufdaten verlassen niemals Ihren Browser - sie bleiben 100% privat auf Ihrem Gerät. Unsere Schlüssel ermöglichen es Ihnen, Downloads freizuschalten, ohne dass wir Ihre persönlichen Daten speichern.'
        },
        validity: {
          '24h': '⏰ Dieser Schlüssel läuft in 24 Stunden ab. Bewahren Sie ihn sicher auf!',
          '7d': '⏰ Dieser Schlüssel läuft in 7 Tagen ab. Bewahren Sie ihn sicher auf!',
          '30d': '⏰ Dieser Schlüssel läuft in 30 Tagen ab. Bewahren Sie ihn sicher auf!'
        },
        footer: {
          tagline: 'privacv - Datenschutz-orientierter Lebenslauf-Builder',
          subtitle: 'Mit ❤️ für Jobsuchende weltweit gemacht'
        }
      },
      plainText: {
        intro: 'Vielen Dank für Ihren privacv-Kauf!',
        passReady: {
          '24h': 'Ihr 24-Stunden-Pass ist bereit.',
          '7d': 'Ihr 7-Tage-Pass ist bereit.',
          '30d': 'Ihr 30-Tage-Pass ist bereit.'
        },
        keyLabel: 'DOWNLOAD-SCHLÜSSEL:',
        instructions: [
          'So verwenden Sie ihn:',
          '1. Gehen Sie zu privacv.de',
          '2. Klicken Sie auf "PDF exportieren" → "Download-Schlüssel eingeben"',
          '3. Fügen Sie Ihren Download-Schlüssel ein und prüfen Sie ihn',
          '4. Laden Sie unbegrenzt PDFs während der Pass-Gültigkeitsdauer herunter'
        ],
        whyKeys: 'Warum Download-Schlüssel? Ihre Lebenslaufdaten bleiben 100% privat auf Ihrem Gerät. Wir speichern niemals Ihre persönlichen Daten.',
        validity: {
          '24h': 'Dieser Schlüssel läuft in 24 Stunden ab.',
          '7d': 'Dieser Schlüssel läuft in 7 Tagen ab.',
          '30d': 'Dieser Schlüssel läuft in 30 Tagen ab.'
        },
        support: 'Benötigen Sie Hilfe? Antworten Sie auf diese E-Mail.',
        signature: 'privacv - Datenschutz-orientierter Lebenslauf-Builder'
      }
    }
  }
};
  